/*
 * Copyright (c)  Hive A.S. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Mehmet Önder, 2021
 */
"use client";
import {createContext, useCallback, useContext, useEffect, useState} from "react";
import {useMediaQuery} from "react-responsive/src";

const mainMenuItemDefinitions = Object.freeze({
  Products: "Products",
  Solutions: "Solutions",
  Resources: "Resources",
  // Company: "Company",
});

const themeOptions = ([
  {value: 'lightest', label: 'Lightest'},
  {value: 'light', label: 'Light'},
  {value: 'dark', label: 'Dark'},
  {value: 'darkest', label: 'Darkest'},
]);

const GlobalStateContext = createContext({
  theme: themeOptions[1].value,
  selectedThemeValue: themeOptions[1],
});

export function useGlobalState() {
  return useContext(GlobalStateContext);
}

export default function GlobalStateProvider({children, location, pageContext}) {
  let data = useProvideGlobalState(pageContext);

  return (
    <GlobalStateContext.Provider value={data}>
      {children}
    </GlobalStateContext.Provider>
  )
}

function useProvideGlobalState(pageContext) {
  const isMobile = useMediaQuery({maxWidth: 767});
  const [theme, setTheme] = useState(themeOptions[1].value);
  const [selectedThemeValue, setSelectedThemeValue] = useState(themeOptions[1]);
  // const {crumbs: breadCrumbList} = pageContext.breadcrumb;
  const [activeMainMenuItem, setActiveMainMenuItem] = useState(undefined);
  const [isMainMenuOpen, setIsMainMenuOpen] = useState(!isMobile);
  const [mainMenuItems] = useState(mainMenuItemDefinitions);

  useEffect(
    () => setIsMainMenuOpen(() => {
      if (!isMobile) {
        setActiveMainMenuItem(undefined);
      }

      return !isMobile;
    }),
    [isMobile, setIsMainMenuOpen]
  );

  useEffect(() => {
    if (!isMainMenuOpen && activeMainMenuItem) {
      setActiveMainMenuItem(undefined);
    }
  }, [activeMainMenuItem, isMainMenuOpen]);

  const toggleMainMenu = useCallback(() => setIsMainMenuOpen(prev => !prev), []);

  const toggleSubMenu = useCallback((menuItem) => {
    if (activeMainMenuItem && activeMainMenuItem === menuItem) {
      setActiveMainMenuItem(undefined);
    } else {
      setActiveMainMenuItem(menuItem);
    }
  }, [activeMainMenuItem]);

  const openMainMenuOf = useCallback((menuItem) => setActiveMainMenuItem(menuItem), []);
  const isMainMenuItemOpen = useCallback((menuItem) => isMainMenuOpen && activeMainMenuItem === menuItem, [activeMainMenuItem, isMainMenuOpen]);

  const setThemeValue = useCallback(({value}) => {
    setTheme(value);
    setSelectedThemeValue(value);
    setTheme(value.value);
  }, [setTheme, setSelectedThemeValue]);

  return {
    theme,
    setTheme,
    selectedThemeValue,
    setThemeValue,
    themeOptions,
    // breadCrumbList,
    isMainMenuOpen,
    setIsMainMenuOpen,
    openMainMenuOf,
    isMainMenuItemOpen,
    isProductsOpen: isMainMenuItemOpen(mainMenuItems.Products),
    isSolutionsOpen: isMainMenuItemOpen(mainMenuItems.Solutions),
    isResourcesOpen: isMainMenuItemOpen(mainMenuItems.Resources),
    // isCompanyOpen: isMainMenuItemOpen(mainMenuItems.Company),
    activeMainMenuItem,
    mainMenuItems,
    toggleMainMenu,
    isMobile,
    toggleSubMenu
  }
}